import {computed, isRef} from 'vue'
import {useConfigStore} from '@/stores/config.js'

export function useConfigData(service) {
  const configStore = useConfigStore()

  const stores = computed(() => configStore.getStores || [])

  const games = computed(() => {
    const serviceName = isRef(service) ? service.value : service
    return configStore.getGamesByService(serviceName) || []
  })
  return {stores, games}
}